import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography, ListItemButton, ListItemText, Collapse } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// assets
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const theme = useTheme();
    const { pathname } = useLocation();

    // کلید یکتا برای ذخیره در مرورگر بر اساس ID هر گروه (مثلاً nav-group-open-accountig)
    const storageKey = `nav-group-open-${item.id}`;

    // بررسی اینکه آیا مسیر (صفحه) فعلی، متعلق به زیرمجموعه‌های این گروه است یا خیر
    const hasActiveChild = item.children?.some((child) => {
        if (!child.url) return false;
        return pathname.includes(child.url) || pathname === child.url;
    });

    // مقداردهی اولیه: اگر زیرمجموعه فعال بود باز باشد، در غیر اینصورت از حافظه مرورگر بخواند
    const [open, setOpen] = useState(() => {
        if (hasActiveChild) return true;
        const storedState = localStorage.getItem(storageKey);
        return storedState === 'true'; // اگر قبلا 'true' ذخیره شده بود باز بماند
    });

    // اگر کاربر از داخل صفحات روی یک لینک کلیک کرد و وارد گروه جدیدی شد، آن گروه خودکار باز شود و در حافظه ثبت شود
    useEffect(() => {
        if (hasActiveChild) {
            setOpen(true);
            localStorage.setItem(storageKey, 'true');
        }
    }, [pathname, hasActiveChild, storageKey]);

    const handleClick = () => {
        const newState = !open;
        setOpen(newState);
        // ذخیره وضعیت جدید در حافظه مرورگر
        localStorage.setItem(storageKey, String(newState));
    };

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List disablePadding>
                {item.title && (
                    <ListItemButton
                        onClick={handleClick}
                        sx={{
                            py: 1.25,
                            px: 2,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            '&:hover': { bgcolor: 'transparent' }
                        }}
                    >
                        <ListItemText
                            primary={
                                <Typography variant="caption" sx={{ ...theme.typography.menuCaption, mb: 0 }} display="block">
                                    {item.title}
                                    {item.caption && (
                                        <Typography
                                            variant="caption"
                                            sx={{ ...theme.typography.subMenuCaption }}
                                            display="block"
                                            gutterBottom
                                        >
                                            {item.caption}
                                        </Typography>
                                    )}
                                </Typography>
                            }
                        />
                        {open ? (
                            <IconChevronUp size={16} stroke={2} style={{ color: theme.palette.grey[500] }} />
                        ) : (
                            <IconChevronDown size={16} stroke={2} style={{ color: theme.palette.grey[500] }} />
                        )}
                    </ListItemButton>
                )}

                {/* قسمت کشویی زیرمجموعه‌ها */}
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List disablePadding>{items}</List>
                </Collapse>
            </List>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 0.25 }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
